import { AccountInfo, AccountPreferences } from '@/types'
import { useFetchWithInterceptor } from '@/use'
import { toRaw } from 'vue'

export const getAccountInfo = async (): Promise<AccountInfo> => {
  const { response, request } = useFetchWithInterceptor<AccountInfo>(`${import.meta.env.VITE_API_URL}/account/info`)
  await request()
  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Response is undefined')
  }
}

export const getAccountPreferences = async (): Promise<AccountPreferences> => {
  const { response, request } = useFetchWithInterceptor<AccountPreferences>(
    `${import.meta.env.VITE_API_URL}/account/preferences`,
  )
  await request()
  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Response is undefined')
  }
}

export const updateAccountPreferences = async (payload: AccountPreferences): Promise<AccountPreferences> => {
  const { response, request } = useFetchWithInterceptor<AccountPreferences>(
    `${import.meta.env.VITE_API_URL}/account/preferences`,
    {
      method: 'PUT',
      body: JSON.stringify(payload),
    },
  )
  await request()
  if (response.value) {
    return toRaw(response.value)
  } else {
    throw new Error('Response is undefined')
  }
}
